import buildProvisionalThreadTitle from '@shared/pieve/buildProvisionalThreadTitle.js';

/**
 * The title a new conversation opens with: the server's provisional title for the request, so the
 * server recognizes it and replaces it with a generated one after the first run starts. With no
 * text, the first file's name.
 */
const toThreadTitle = (prompt, attachments = []) => {
  if (!String(prompt || '').trim()) {
    return attachments[0]?.filename || 'New request';
  }

  return buildProvisionalThreadTitle(prompt);
};

export default toThreadTitle;
